<br>
<fieldset>
	<legend>Link - [Create & Deletion]</legend>
	<dx-data-grid [dataSource]="auditLogData" height="100%" [showBorders]="true" [wordWrapEnabled]="true">
		<dxo-selection [showCheckBoxesMode]="'none'"></dxo-selection>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxi-column dataField="timeStamp" sortOrder="desc" [width]="110" cellTemplate="timestampTemplate">
		</dxi-column>
		<dxi-column dataField="userId" [width]="50"></dxi-column>
		<dxi-column dataField="username" [width]="150"></dxi-column>
		<dxi-column dataField="recordId" [width]="100"></dxi-column>
		<dxi-column dataField="recordType" [width]="150"></dxi-column>
		<dxi-column dataField="auditAction" [width]="100"></dxi-column>
		<dxi-column dataField="additionalData" cellTemplate="cellTemplate"></dxi-column>
		<div *dxTemplate="let data of 'timestampTemplate'">
			<!-- {{data.value}} -->
			{{data.value | date:'d/MM/yyyy H:mm'}}
		</div>
		<div *dxTemplate="let data of 'cellTemplate'">
			<!-- {{data.value}} -->
			{{convertAdditionalDataToReadableText(data.data)}}
		</div>
	</dx-data-grid>
</fieldset>
